module.exports = __webpack_public_path__ + "static/media/rhodium3.15c60fcf.jpg";